import {
  FeatureFlag,
  useFeatureFlag,
} from "@adsk/acc-issues-core/utils/featureFlags";
import { useCallback, useState } from "react";

export const useIssueDeletionComment = () => {
  const maxCommentLength = 1000;
  const [issueDeletionComment, setIssueDeletionCommentInternal] =
    useState<string>("");

  const [isCommentTruncated, setIsCommentTruncated] = useState<boolean>(false);

  const { value: isAbleToDeleteWithComment } = useFeatureFlag(
    FeatureFlag.DeleteWithComment
  );

  const setIssueDeletionComment = useCallback(
    (newValue: string) => {
      let valueToSet;
      if (newValue.length > maxCommentLength) {
        valueToSet = newValue.substring(0, maxCommentLength);
        setIsCommentTruncated(true);
      } else {
        valueToSet = newValue;
        setIsCommentTruncated(false);
      }
      setIssueDeletionCommentInternal(valueToSet);
    },
    [maxCommentLength, setIssueDeletionCommentInternal]
  );

  return {
    issueDeletionComment,
    isCommentTruncated,
    setIssueDeletionComment,
    isAbleToDeleteWithComment,
    maxCommentLength,
  };
};
